/**
 * Az eseményenként felülírható e-mail sablonok kódjai.
 *
 * A `PASSWORD_RESET` szándékosan NINCS itt (#109): a jelszó-visszaállító
 * levél nem tartozik eseményhez, a rendszer eseményfüggetlen úton küldi, és
 * egy itt szerkesztett felülírás soha nem jutna el senkihez. A kód a
 * kiszolgáló enumjában megmarad, de a szervező elől el kell rejteni.
 */
export type EmailTemplateCode =
  | 'REGISTRATION_CONFIRMED'
  | 'REGISTRATION_APPROVED'
  | 'PAYMENT_INSTRUCTIONS'
  | 'PAYMENT_REMINDER'
  | 'PAYMENT_RECEIVED_COMPANY'
  | 'ENTRY_QR'
  | 'PAYMENT_EXPIRED';

export const EMAIL_TEMPLATE_CODES: EmailTemplateCode[] = [
  'REGISTRATION_CONFIRMED',
  'REGISTRATION_APPROVED',
  'PAYMENT_INSTRUCTIONS',
  'PAYMENT_REMINDER',
  'PAYMENT_RECEIVED_COMPANY',
  'ENTRY_QR',
  'PAYMENT_EXPIRED',
];
